import React, { useState, useEffect, useRef } from "react";
import Modal from "../../Modal/Modal.js";
import Button from "../../Button/Button.js";
import "./Cropper.scss";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import { B64Upload } from "../../../utils/api";

const CropperModal = ({ onCropDone, onClose, url }) => {
  const [size, setSize] = useState(null);
  const [loading, setLoading] = useState(false);
  const cropper = useRef(null);

  useEffect(() => {
    const image = document.getElementById("image");
    cropper.current = new Cropper(image, {
      viewMode: 2,
      dragMode: "move",
      aspectRatio: 1,
      minContainerWidth: 570,
      minContainerHeight: 400,
      minCanvasWidth: 400,
      minCanvasHeight: 400,
      minCropBoxWidth: 400,
      minCropBoxHeight: 400
    });
    window.cropper = cropper.current;
  }, []);

  const onImageLoad = e => {
    setSize({ width: e.target.width, height: e.target.height });
  };

  const onSave = () => {
    const data = cropper.current.getCroppedCanvas().toDataURL();
    console.log(data);
    B64Upload(data).then(resp => {
      console.log(resp);
      onCropDone(resp.image);
    });
  };

  return (
    <Modal className="smi-cropper" onClose={onClose}>
      <div className="modal__header">
        <div className="modal__title">
          Загрузка изображения {size && `(${size.width}x${size.height})`}
        </div>
        <div className="modal__controls">
          <Button color="gray" onClick={onClose}>
            Отмена
          </Button>
          <Button color="blue" onClick={onSave} disabled={loading}>
            Сохранить
          </Button>
        </div>
      </div>
      <div className="modal__body">
        <div className="image-holder">
          <img
            onLoad={onImageLoad}
            id="image"
            src={url}
            className="smi-cropper__image"
          />
        </div>
      </div>
    </Modal>
  );
};

export default CropperModal;
